<template>
  <div class="-asset-icons" :class="{ '-no-gradient': !gradient }">
    <div
      v-for="(icon, i) in icons"
      class="-icon"
      :class="'-' + icon.boxClass"
      :key="i"
    >
      <template v-if="icon.iconClass">
        <i v-tooltip="iconTooltip(icon)" :class="icon.iconClass">
          <i class="path1"></i>
          <i class="path2"></i>
        </i>
      </template>
      <span v-if="icon.iconText">{{ icon.iconText }}</span>
    </div>
    <div v-if="author" class="-post-author">{{ author }}</div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  methods: {
    iconTooltip(icon) {
      if (!icon.title && !icon.showRestrictions) {
        return false;
      }

      const tooltip = {
        title: icon.title,
        placement: 'bottom auto',
        wrapperClass: 'tooltip-lightbox-wrapper',
        delay: { show: 250, hide: 0 },
      };

      if (icon.showRestrictions && this.restrictions) {
        Object.assign(tooltip, {
          wrapperClass: 'tooltip-restrictions-wrapper',
          title: `
<div class="tooltip-restrictions">
    <div class="-title">Restrictions:</div>
    <div class="-description">${this.restrictions}</div>
</div>`.normalizeSpace(),
          html: true,
        });
      }
      return tooltip;
    },
  },

  props: {
    restrictions: {
      type: String,
      required: false,
    },
    icons: {
      type: Array,
      required: true,
    },
    gradient: {
      type: Boolean,
      required: false,
      default: true,
    },
    author: {
      type: [String, Boolean],
      required: false,
      default: false,
    },
  },
});
</script>
